// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__3gTw1","headerIcon":"header_headerIcon__RPZIh","headerText":"header_headerText__27AYP"};